'use client'

import TOCInline from 'pliny/ui/TOCInline.js'
import { useTranslations } from 'next-intl'
import { type Locale } from '@/navigation'
import { useParams } from 'next/navigation'
//import CustomTOC from './CustomTOC' 
import useSidebarStore from './store'
import type { Toc, TocItem as OriginalTocItem } from 'pliny/mdx-plugins/remark-toc-headings.js'

interface TocBodyProps {
  toc: Toc
}

interface TocItem extends OriginalTocItem {
  children?: TocItem[]
}

const filterToc = (toc: TocItem[]): TocItem[] => {
  return toc.map((item) => {
    const modifiedValue = item.url.replace(/-\d+$/, '')
    return {
      ...item,
      url: modifiedValue,
    }
  })
}

// const filterToc = (toc: TocItem[]): TocItem[] => {
//   return toc.map((item) => item)  // This will keep the original URLs
// }

const TocBody = ({ toc }: TocBodyProps) => {
  const locale = useParams()?.locale as Locale
  const t  = useTranslations('blog.common')
  const { sidebarOpen } = useSidebarStore()

  if (!sidebarOpen) {
    return null
  }

  const filteredToc = filterToc(toc as TocItem[])

  return (
    <div className="fixed left-0 top-0 z-50 h-screen md:flex">
      <div className="fixed left-0 top-0 z-50 flex h-screen w-64 flex-col bg-gray-100 px-2 py-4 dark:bg-gray-800">
        <div className="mt-20">
          <div className="text-xl font-bold text-heading-400">{t('sidetoc')}</div>
          <div className="my-auto mt-5 overflow-y-auto">
            <TOCInline
              toc={filteredToc}
              ulClassName="space-y-2 overflow-y-auto my-auto text-primary-500"
              liClassName="hover:text-heading-400"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default TocBody
